/**
 *
 * runtime-config constants
 *
 */

export const CONFIG_KEY = 'runtimeConfig';

export const SET_ADOBE_TARGET = `mlb/${CONFIG_KEY}/SET_ADOBE_TARGET`;